export default __webpack_public_path__ + "static/dcNDXtDG-2fac17768dbb0c5deb0760ac9e776e78.svg";